import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';

import 'normalize.css';
import '@/styles/main.scss';

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.NODE_ENV === 'production'
    ? 'https://api.resetting.ru'
    : 'http://localhost:8888';

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
